<template>
<b-dropdown right no-caret>
  <template slot="button-content">
    <img src="static/img/assets/edit.png">
  </template>
  <div v-if="tag==='OrganizationItem'">
    <b-dropdown-item :to="{ name: 'OrganizationEdit', params: { item: getItem, id: getKey } }">{{$t('editStr')}}</b-dropdown-item>
    <b-dropdown-item :disabled=checkDisabled @click.stop="onClickDelete">{{$t('deleteStr')}}</b-dropdown-item>
  </div>
  <div v-else>
    <b-dropdown-item :to="{ name: 'ManageGroupEdit', params: { item: getItem, id: getKey } }">{{$t('editStr')}}</b-dropdown-item>
    <b-dropdown-item @click.stop="onClickDelete">{{$t('deleteStr')}}</b-dropdown-item>
  </div>
</b-dropdown>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'GroupDropDown',
  props: {
    tag: String,
    item: Object,
    id: String
  },
  data () {
    return {
      removeTarget: {
        id: '',
        target: ''
      }
    }
  },
  computed: {
    ...mapGetters('groups/', [
      'getGroupById'
    ]),
    getStatus: function () {
      return this.tag
    },
    getItem: function () {
      return this.item
    },
    getKey: function () {
      return this.id
    },
    checkDisabled: function () {
      let organization = this.getGroupById(this.id)
      return (organization.hasOwnProperty('childGroups') || organization.hasOwnProperty('members'))
    }
  },
  methods: {
    ...mapActions({
      removeItem: 'REMOVE_ITEM'
    }),
    ...mapActions('groups/', {
      removeGroup: 'REMOVE_GROUP',
      setGroupInactive: 'SET_GROUP_INACTIVE'
    }),
    onClickDelete: function () {
      this.removeTarget.id = this.id
      this.removeTarget.target = 'groups'
      const $t = this.$t
      this.setGroupInactive(this.removeTarget)
      this.removeGroup(this.removeTarget)
      this.$swal({
        title: $t('compDeleteStr'),
        type: 'success',
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        padding: '2rem',
        timer: 3000
      })
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Manage/ManageGroupDropDown.vue